/* WizardIconColumnComponent.js */

"use strict";

const DefaultColumnComponent = require('../default/DefaultColumnComponent');
const Renderer = require("./WizardIconColumnRenderer");
// const _ = require('lodash');

class WizardIconColumnComponent extends DefaultColumnComponent {

    constructor(value) {
        super(value);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/


    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/


    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = WizardIconColumnComponent;